"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20.439 4.948c.93.246 1.661.972 1.91 1.894C22.8 8.513 22.8 12 22.8 12s0 3.487-.451 5.158a2.695 2.695 0 0 1-1.91 1.894C18.755 19.5 12 19.5 12 19.5s-6.754 0-8.439-.448a2.695 2.695 0 0 1-1.91-1.894C1.2 15.487 1.2 12 1.2 12s0-3.487.451-5.158a2.694 2.694 0 0 1 1.91-1.894C5.246 4.5 12 4.5 12 4.5s6.755 0 8.439.448ZM9.84 8.785v6.43L15.452 12 9.84 8.785Z"
})), "0 0 24 24", "Youtube");